import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class PetSpecies extends Enum {
  key!: string;
  value!: string;

  static CAT: PetSpecies = {
    key: 'cat',
    get value(): string {
      return Lang.t('pet.cat');
    }
  };

  static DOG: PetSpecies = {
    key: 'dog',
    get value(): string {
      return Lang.t('pet.dog');
    }
  };

  static FISH: PetSpecies = {
    key: 'fish',
    get value(): string {
      return Lang.t('pet.fish');
    }
  };

  static HORSE: PetSpecies = {
    key: 'horse',
    get value(): string {
      return Lang.t('pet.horse');
    }
  };

  static RABBIT: PetSpecies = {
    key: 'rabbit',
    get value(): string {
      return Lang.t('pet.rabbit');
    }
  };

  static OTHER: PetSpecies = {
    key: 'other',
    get value(): string {
      return Lang.t('pet.other');
    }
  };
}
